import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslations } from "@jti/ui";
import { useLoyaltyStatus } from "../../../hooks/useLoyaltyStatus";
import styles from "./ProductPoints.module.scss";
export const ProductPoints = ({ pointsQuantity }) => {
    const { __ } = useTranslations();
    const loyaltyStatus = useLoyaltyStatus();
    if (pointsQuantity <= 0 || !loyaltyStatus) {
        return null;
    }
    return (_jsxs("div", { className: styles.points, "data-testid": "product-points", children: [__("cart.ploom_club.earn"), _jsx("span", { className: styles.pointsQuantity, "data-testid": "cart-points-earn", children: ` ${pointsQuantity} ` }), _jsx("span", { className: styles.ploom, children: "Ploom Club " }), pointsQuantity == 1 ? __("cart.ploom_club.point") : __("cart.ploom_club.points")] }));
};
//# sourceMappingURL=ProductPoints.js.map